import React, { useState, useEffect } from "react";
import {
  Card,
  Button,
  Table,
  message,
  Modal,
  Space,
  Descriptions,
  Input,
  Alert,
} from "antd";
import {
  DatabaseOutlined,
  ReloadOutlined,
  DeleteOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import httpUtil from "../../../../utils/httpUtil";

export const SysData = () => {
  const [backupList, setBackupList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [backupName, setBackupName] = useState("");
  const [createdBy, setCreatedBy] = useState("");

  // 获取备份列表
  const getAllBackups = async () => {
    setLoading(true);
    try {
      httpUtil.getBackups().then((res) => {
        if (res.success) {
          setBackupList(res.data);
        } else {
          message.error(res.error || "获取备份列表失败");
        }
      });
    } catch (error) {
      message.error("获取备份列表失败");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllBackups();
  }, []);

  // 创建备份
  const handleCreateBackup = async () => {
    if (!backupName || !createdBy) {
      message.error("请输入备份名称和备份人");
      return;
    }

    setLoading(true);
    try {
      const params={
          backup_name: backupName,
          created_by: createdBy,
        }
      httpUtil.backupDatabase(params).then((res) => {
        console.log(res);
        if (res.success) {
        message.success("数据库备份成功");
        setBackupName("");
        setCreatedBy("");
        getAllBackups();
      } else {
        message.error(res.error || "备份创建失败");
      }
      })

    } catch (error) {
      message.error("备份创建失败");
    } finally {
      setLoading(false);
    }
  };

  // 恢复数据库
  const handleRestoreDatabase = async (backupId) => {
    Modal.confirm({
      title: "确认恢复数据库",
      content: "此操作将使用选定的备份完全覆盖当前数据库，不可逆转！",
      okText: "确认恢复",
      okType: "danger",
      cancelText: "取消",
      onOk: async () => {
        setLoading(true);
        try {
          const params={
              backup_id: backupId,
            }
          httpUtil.restoreDatabase(params).then((res) => {
            console.log(res);
            if (res.success) {
                message.success("数据库恢复成功");
                getAllBackups();
              } else {
                message.error(res.error || "数据库恢复失败");
              }
          })
        } catch (error) {
          message.error("数据库恢复失败");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  // 删除备份
  const handleDeleteBackup = async (backupId) => {
    Modal.confirm({
      title: "确认删除备份",
      content: "此操作将永久删除该备份文件，是否继续？",
      okText: "确认删除",
      okType: "danger",
      cancelText: "取消",
      onOk: async () => {
        setLoading(true);
        try {
          const params = { backup_id: backupId };
          httpUtil.deleteBackup(params).then((res) => {
            if (res.success) {
              message.success("备份删除成功");
              getAllBackups();
            } else {
              message.error(res.error || "备份删除失败");
            }
          });
        } catch (error) {
          message.error("备份删除失败");
        } finally {
          setLoading(false);
        }
      },
    });
  };

  // 表格列定义
  const columns = [
    {
      title: "备份名称",
      dataIndex: "backup_name",
      key: "backup_name",
      render: (text) => (
        <span>
          <DatabaseOutlined style={{ marginRight: 8 }} />
          {text}
        </span>
      ),
    },
    {
      title: "备份时间",
      dataIndex: "created_at",
      key: "created_at",
      render: (text) => (
        <span>
          <ClockCircleOutlined style={{ marginRight: 8 }} />
          {new Date(text).toLocaleString()}
        </span>
      ),
    },
    {
      title: "备份人",
      dataIndex: "created_by",
      key: "created_by",
    },
    {
      title: "操作",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="link"
            icon={<ReloadOutlined />}
            onClick={() => handleRestoreDatabase(record.backup_id)}
          >
            恢复
          </Button>
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDeleteBackup(record.backup_id)}
          >
            删除
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: "24px" }}>
      <Card
        title="数据库备份与恢复"
        variant={false}
        extra={
          <Space>
            <Button
              type="primary"
              icon={<DatabaseOutlined />}
              onClick={handleCreateBackup}
              loading={loading}
            >
              创建备份
            </Button>
          </Space>
        }
      >
        <div style={{ marginBottom: 16 }}>
          <Space>
            <Input
              placeholder="备份名称"
              value={backupName}
              onChange={(e) => setBackupName(e.target.value)}
              style={{ width: 200 }}
            />
            <Input
              placeholder="备份人"
              value={createdBy}
              onChange={(e) => setCreatedBy(e.target.value)}
              style={{ width: 200 }}
            />
          </Space>
        </div>

        <Alert
          message="重要提示"
          description={
            <Descriptions column={1}>
              <Descriptions.Item label="备份功能">
                创建备份将保存当前数据库所有表的数据
              </Descriptions.Item>
              <Descriptions.Item label="恢复功能">
                恢复操作将完全覆盖当前数据库，请谨慎操作
              </Descriptions.Item>
            </Descriptions>
          }
          type="warning"
          showIcon
          style={{ marginBottom: 24 }}
        />

        <Table
          columns={columns}
          dataSource={backupList}
          rowKey="backup_id"
          loading={loading}
          pagination={{
            pageSize: 10,
            showSizeChanger: true,
            showTotal: (total) => `共 ${total} 个备份`,
          }}
        />
      </Card>
    </div>
  );
};
